import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { appSliceDefault } from "../redux/AppSlice"
import { userSliceDefault } from "../redux/UserSlice"
import { addressSliceDefault } from "../redux/AddressSlice"
import { useSelector } from "react-redux"
import errorName from "./Variables"
import { cartSliceDefault } from "../redux/CartSlice"
import { orderSliceDefault } from "../redux/OrderSlice"
import { shopSliceDefault } from "../redux/ShopSlice"
import { wholesaleSliceDefault } from "../redux/WholesaleSlice"
import { productSliceDefault } from "../redux/ProductSlice"

// solve error and return response
function catchError(error) {
    // error.response.data.detail = permsision error 
    // error.response.data.message = limit reached

    if (error && error.message === 'Network Error') {
        return { 'error_message': 'Oops! No connection with server, Try again.', 'type': 'exception' }
    }
    else if (error.response.status === 500) {
        return { 'error_message': 'Oops ! Something went wrong, Please login again.', 'type': 'exception' }
    }
    else if (error.response.data.detail === "User not found") {
        return { 'error_message': errorName.userNotFound, 'type': 'exception' }
    }
    else if (error.response.data.detail === errorName.notNormalUser) {
        return { 'error_message': errorName.notNormalUser, 'type': 'exception' }
    }
    else if (error.response.data.detail) {
        return { 'error_message': errorName.authenticationError, 'type': 'exception' }
    }
    else if (error.response.data.message) {
        return { 'error_message': error.response.data.message, 'type': 'exception' }
    }
    else {
        return { 'error_message': errorName["404Error"], 'type': 'exception' }
    }
}
// get the token or null
function getToken() {
    const token = localStorage.getItem('ah@u#t#22!01')
    try {
        if (token) {
            return JSON.parse(token)
        }
        return null
    }
    catch (error) {
        return null
    }
}

// set the token 
function setToken(token) {
    localStorage.setItem('ah@u#t#22!01', JSON.stringify(token))
}

// remove token
function removeToken() {
    localStorage.removeItem('ah@u#t#22!01')
}

// clear all data of slice and perform operation when user logged in or logged out 
function setDefaultAll(dispatch = null, logout = false) {
    if (dispatch) {
        if (logout) {
            removeToken()
        }
        else {
            dispatch(userSliceDefault())
            dispatch(addressSliceDefault())
            dispatch(cartSliceDefault())
            dispatch(orderSliceDefault())
            dispatch(shopSliceDefault())
            dispatch(wholesaleSliceDefault())
            dispatch(productSliceDefault())
        }
        dispatch(appSliceDefault())
    }
}

// handle the createAsyncThunk request
function handleRequest(request, rejectWithValue) {
    return request.data && request.data.error_message ?
        rejectWithValue(request.data) :
        request.data
}

// get the current path name in encodedFormate - /pathname/?parms 
function getPathName(location) {
    return location.pathname === '/' ? '/' : encodeURIComponent(`${location.pathname}${location.search}`)
}

// get the value of redirect params
function getRedirectPath(location) {
    const redirect = new URLSearchParams(location.search).get('redirect')
    return redirect ? redirect : '/'
}

// scroll to top when page change
function ScrollToTop() {
    const { pathname } = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}


// convert field to slug 
function slugify(field, append = '', product = true) {
    try {
        return encodeURIComponent(append != '' ? product ?
            `${field.replace(/\s+/g, '-')}-ahp${append}` : `${field.replace(/\s+/g, '-')}-ahs${append}` : field.replace(/\s+/g, '-'))
    }
    catch (error) {
        return ''
    }
}


// convert amount 100000 to 10,00,00

function getFormatedAmount(amount = 0) {
    const a = amount === null ? 0 : new Intl.NumberFormat().format(amount)
    // return `${String.fromCharCode(8377)} ${a}`;
    return a
}

// get the sort by value to sort 
function getSortBy(option) {
    switch (option) {
        case 'p-hl':
            return '-price'
        case 'p-lh':
            return 'price'
        case 'd-no':
            return '-added_on'
        case 'd-on':
            return 'added_on'
        case 'ds-hl':
            return '-discount'
        case 'ds-lh':
            return 'discount'
        default:
            return '-added_on'
    }
}

// get the field error message { error, field_name }
function getFieldErrorMessage(error, field) {
    return { 'error_message': error, 'field': field }
}


// get the iframe content
function getIframeScr(iframe = null) {
    if (iframe) {
        const srcIndex = iframe.indexOf('src="');
        if (srcIndex === -1) {
            return null
        }
        const start = srcIndex + 5; // Move index to start of actual URL
        const end = iframe.indexOf('"', start); // Find closing quote
        return iframe.slice(start, end);
    }
    else {
        return null
    }
}


function getDiscount(mrp, price) {
    try {
        return (((mrp - price) * 100) / mrp).toFixed(1)
    }
    catch (error) {
        return 0
    }
}


async function copyToClipboard(message = '') {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(message);
            alert('Page link copied to clipboard!');
        } else {
            // Fallback for older browsers and in-app mobile browsers
            const textarea = document.createElement('textarea');
            textarea.value = message;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            const successful = document.execCommand('copy');
            document.body.removeChild(textarea);

            if (successful) {
                alert('Page link copied to clipboard!');
            } else {
                alert('Can not copy page link to clipboard.');
            }
        }
    } catch (error) {
        alert(error)
    }
}

// scroll to 
function scrollFocus(ref) {
    const height = window.innerHeight;
    const width = window.innerWidth;
    if (ref.current) {
        // if ((width > 650 && height > 950) || (width > 950 && height > 650)) {
        // ref.current.readOnly = true;
        ref.current?.focus();
        // }
        // ref.current.readOnly = false;
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (ref.current && ref.current.style) {
            ref.current.style.borderBottom = '2px solid #99582A';
            setTimeout(() => {
                ref && ref.current && ref.current.style ?
                    ref.current.style.borderBottom = '' : <></> // Reset border color after 2 seconds
            }, 4000);
        }
    }
}


// function to check links 
function isValidLink(link) {
    if (!link || (link && link.trim() === '')) {
        return { 'link': '#', 'target': '' }
    }
    return { 'link': link, 'target': '_blank' }
}


// convert product color field for json ld 
function normalizeColorForJsonLd(colorString) {
    if (!colorString || typeof colorString !== "string") return [];

    // 1. Extract bracketed colors (like "bluish green")
    let bracketMatches = [];
    const bracketRegex = /\((.*?)\)/g;
    let match;
    while ((match = bracketRegex.exec(colorString)) !== null) {
        bracketMatches.push(match[1].trim().toLowerCase());
    }

    // 2. Remove everything inside parentheses
    let cleanString = colorString.replace(/\(.*?\)/g, "");

    // 3. Replace connectors with comma
    cleanString = cleanString
        .replace(/\s+(and|or|&)\s+/gi, ",")
        .replace(/-/g, ","); // handle cases like "red-yellow"

    // 4. Split by comma
    let parts = cleanString
        .split(",")
        .map(p => p.trim().toLowerCase())
        .filter(Boolean);

    // 5. Merge with bracket colors
    let finalColors = [...parts, ...bracketMatches];

    return finalColors;
}

// Core colors dictionary (expandable)
const coreColors = [
    "red", "blue", "green", "yellow", "orange",
    "pink", "purple", "brown", "black", "white",
    "gray", "grey", "gold", "beige", "maroon",
    "teal", "violet", "lavender", "ivory", "peach", "cream"
];


function normalizeColorForApi(colorString) {
    if (!colorString || typeof colorString !== "string") return '';

    let cleaned = colorString
        .replace(/\band\b/gi, ",")
        .replace(/\bor\b/gi, ",")
        .replace(/-/g, " ")
        .replace(/\(|\)/g, ",")
        .replace(/\s+/g, " ")
        .trim();

    let normalized = cleaned
        .split(",")
        .map(p => p.trim().toLowerCase())
        .filter(Boolean);

    let filtered = [];
    normalized.forEach(c => {
        coreColors.forEach(core => {
            if (c.includes(core)) {
                filtered.push(core);
            }
        });
    });

    // Remove duplicates
    return [...new Set(filtered)].join(" ");
}


// ------------------------------------------------we will use them later-----------------------------------------



// get the date in this formate -> dd/mm/yy
function getDate(date = null) {
    if (date) {
        return new Date(date).toLocaleDateString('en-GB')
    }
    else {
        return new Date().toLocaleDateString('en-GB')
    }
}


// get the time in this formate -> 10:25:10 PM
function getTime(time = null, only_time = false) {
    // console.log(JSON.stringify(time).replace(" ",""), only_time)
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    };

    if (only_time) {
        const t = time.split(':')
        const hour = t[0]
        const min = t[1]
        const sec = t[2] ? t[2] : '00'

        if (hour > 12 && hour < 24) {
            return `${hour - 12 >= 0 && hour - 12 <= 9 ? '0' : ''}${hour - 12}:${min}:${sec} PM`
        }
        else if (hour === '00') {
            return `00:${min}:${sec} AM`
        }
        else if (hour === '12') {
            return `12:${min}:${sec} PM`
        }
        return `${hour}:${min}:${sec} AM`
    }
    else {
        if (time) {
            return new Date(time).toLocaleTimeString('en-US', options).toUpperCase();
        } else {
            return new Date().toLocaleTimeString('en-US', options).toUpperCase();
        }
    }
}

// get the name of the day by date
function getDayName(dateString) {
    const date = new Date(dateString);
    const options = { weekday: 'long' };  // This will return the full day name (e.g., "Monday")
    return new Intl.DateTimeFormat('en-US', options).format(date);
};

// check wheater the data is presenet or it is null
function haveData(data, msg = '', message = null) {
    return data ? data === '' || data === null || data === 0 || data === '0' || (data !== null && data.length === 0) ?
        message ? message : 'No Data' : `${data} ${msg}` : 'No Data'
}

// move to next when enter is clicked
function nextOnEnter(e, nextRef) {
    if (e.key === 'Enter') {
        e.preventDefault()
        nextRef && nextRef.current ?
            nextRef.current.focus() : <></>
    }
}


function CheckItemInCartItemList(product) {
    const cart_item_list = useSelector((state) => state.cartSlice.cart_item_list)
    return cart_item_list[`p${product}`] ? true : false
}

// delay before calling function so that any animation performs
function delayForFunction(funcName, params) {
    const time = setTimeout(() => {
        params ? funcName(params) : funcName()
    }, [600])
    return () => clearTimeout(time)
}



function sendWS(socket, data) {
    const stringify = JSON.stringify(data)
    console.log('This data is sending to WS', stringify)
    socket.send(stringify)
}

function parseData(data) {
    return JSON.parse(data)
}

export default catchError;
export { handleRequest, getToken, getSortBy, setToken, removeToken, getDiscount, getFormatedAmount, setDefaultAll, slugify, getPathName, getRedirectPath, getDate, getTime, getDayName, getFieldErrorMessage, ScrollToTop, nextOnEnter, scrollFocus, haveData, delayForFunction, sendWS, parseData, CheckItemInCartItemList, getIframeScr, copyToClipboard, isValidLink, normalizeColorForJsonLd, normalizeColorForApi }

